import { useState, useEffect } from 'react';

export function useWorkItems(supabase, user) {
  const [workItems, setWorkItems] = useState([]);

  useEffect(() => {
    async function fetchWork() {
      if (!supabase || !user?.proj?.id) return;
      const { data } = await supabase
        .from("work")
        .select()
        .eq("project_id", user.proj.id)
        .order("id", { ascending: true });
      setWorkItems(data || []);
    }
    fetchWork();
  }, [supabase, user]);

  return { workItems, setWorkItems };
}

